/**
 * @generated SignedSource<<a8a71ac11082f0dcaf74350dca00acb0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MeetingRecordingUserSession = {
  sections: ReadonlyArray<MeetingRecordingUserSection>;
  sessionEnd?: string | null;
  sessionId: string;
  sessionStart: string;
};
export type MeetingRecordingUserSection = {
  endTime: number;
  startTime: number;
};
export type SessionManagerSubmitSessionMutation$variables = {
  clipId?: string | null;
  meetingRecordingId?: string | null;
  session: MeetingRecordingUserSession;
};
export type SessionManagerSubmitSessionMutation$data = {
  readonly submitSessionForRecordingUser: {
    readonly ok: boolean;
  } | null;
};
export type SessionManagerSubmitSessionMutation = {
  response: SessionManagerSubmitSessionMutation$data;
  variables: SessionManagerSubmitSessionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "clipId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "meetingRecordingId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "session"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "clipId",
        "variableName": "clipId"
      },
      {
        "kind": "Variable",
        "name": "meetingRecordingId",
        "variableName": "meetingRecordingId"
      },
      {
        "kind": "Variable",
        "name": "session",
        "variableName": "session"
      }
    ],
    "concreteType": "SubmitSessionForRecordingUser",
    "kind": "LinkedField",
    "name": "submitSessionForRecordingUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SessionManagerSubmitSessionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SessionManagerSubmitSessionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5c79b150cc9abea582e3aa1fe32a4a4f",
    "id": null,
    "metadata": {},
    "name": "SessionManagerSubmitSessionMutation",
    "operationKind": "mutation",
    "text": "mutation SessionManagerSubmitSessionMutation(\n  $clipId: ID\n  $meetingRecordingId: ID\n  $session: MeetingRecordingUserSession!\n) {\n  submitSessionForRecordingUser(session: $session, meetingRecordingId: $meetingRecordingId, clipId: $clipId) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "cab4c6f46c0db0f5bc8930801498e0de";

export default node;
